import tbwEventDetailBanner from "public/images/tbw-banner/event-detail-page.png";
import Image from "next/image";
import {
  BsQuestionCircleFill,
  BsTelegram,
  FaDiscord,
  MdEmail,
  AvalancheIcon,
  GcpIcon,
  GoIcon,
  MoongateIcon,
} from "components";
import { Button, Icon } from "@chakra-ui/react";

const TicketBannerSection = ({
  t,
  loading,
  buyTicket,
}: {
  t: any;
  loading: boolean;
  buyTicket: () => void;
}) => {
  return (
    <div className="flex flex-col w-full max-w-[500px] ">
      <Image
        style={{ borderRadius: "0.25rem 0.25rem 0 0" }}
        src={tbwEventDetailBanner}
        alt="Avax park"
      />

      <div className="flex flex-row ">
        {/* <Button
          flexBasis={0}
          flexGrow={1}
          borderRadius='0 0 0 0.25rem'
          bgColor='transparent'
          border='2px solid '
          borderColor='primary.300'
          py='4'
          fontWeight={600}
          fontSize='1rem'
          as='a'
          href='https://app.moongate.id/discover?tags=TBW2022'
          target='_blank'
        >
          {t("seeSideEvents")}
        </Button> */}
      </div>

      {/*
      <div className="flex flex-row bg-glass py-4 md:px-4 rounded-lg mt-8 items-center">
        <div className="flex flex-row justify-center w-1/4 flex-shrink-0">
          <Icon as={BsQuestionCircleFill} w="10" h="10" />
        </div>
        <div className="flex flex-col flex-grow justify-center items-start">
          <p className="text-base font-semibold mb-2">{t("faceIssue")}?</p>
          <div className="flex flex-row items-center">
            <p className="text-md mr-4">{t("contactUs")}:</p>
            <a
              className="mr-4"
              href="mailto:support@moongate.id"
              target="_blank"
              rel="noreferrer"
            >
              <MdEmail size="2em" />
            </a>

            <a
              className="mr-4"
              href="https://t.me/pweeh"
              target="_blank"
              rel="noreferrer"
            >
              <BsTelegram size="1.6em" />
            </a>

            <a
              className="mr-4"
              href="https://discord.com/channels/948159905494335488/1029694761243791381"
              target="_blank"
              rel="noreferrer"
            >
              <FaDiscord size="2em" />
            </a>
          </div>
        </div>
      </div>
      */}

      {/* <div className='flex flex-row items-center self-end my-6 md:my-8'>
        <div className='text-secondary'>{t("sponsoredBy")}</div>

        <div className='flex flex-row items-center gap-5 ml-4'>
          <div className='w-8 flex flex-col justify-center '>
            <Image src={AvalancheIcon} alt='avalanche icon' />
          </div>
          <div className='w-8 flex flex-col justify-center '>
            <Image src={GcpIcon} alt='gcp icon' />
          </div>
          <div className='w-8 flex flex-col justify-center '>
            <Image src={MoongateIcon} alt='moongate icon' />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TicketBannerSection;
